import { Avatar, Button, Card, CardHeader, Grid, Typography } from '@mui/material'
import PageContainer from '@/components/ui/containers/PageContainer'
import { Step } from './components/StepComponent'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useMemo } from 'react'
import { mapOnboardingProgressToStepsProps } from '@/utils/onboarding/main'
import { OnboardingProgressCard } from './components/StepProgress'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '@/hooks/useSizeBreakpoints';
import SchoolIcon from '@mui/icons-material/School'
import { Box, useTheme } from '@mui/system'


export function OnboardingPage() {
  const authUser = useAppSelector(selectAuthUser)
  const { t } = useTranslation()
  const theme = useTheme()
  const onBoardingSteps = useMemo(() => {
    if (!authUser?.onboardingProcess) return []
    return mapOnboardingProgressToStepsProps(authUser.onboardingProcess)
  }, [authUser])

  const isTooSmall = useIsMobile()

  return (
    <PageContainer>
      {!isTooSmall ? (
        <Grid container spacing={2} direction="row">
          <Grid item xs={8}>
            <Card variant="outlined" sx={{ marginBottom: 2, elevation: 3 }} key={'onboardingpage-title'}>
              <CardHeader
                title={<Typography variant="h5">{t('page.onboarding.courses.title')}</Typography>}
                avatar={
                  <Avatar sx={{ backgroundColor: theme.palette.primary.main, color: 'white' }}>
                    <SchoolIcon />
                  </Avatar>
                }
                action={
                  <>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        window.open('https://learn.medconnect.services/login', '_blank')
                      }}
                    >
                      {t('page.onboarding.courses.CTA')}
                    </Button>
                  </>
                }
              />
            </Card>
            {onBoardingSteps.map((step) => {
              return <Step key={step.title} {...step} />
            })}
          </Grid>
          <Grid item xs={4}>
            <OnboardingProgressCard steps={onBoardingSteps} />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2} direction="row">
          <Grid item>
            <OnboardingProgressCard steps={onBoardingSteps} />
          </Grid>
          <Grid item xs={12}>
            <Card variant="outlined" sx={{ marginBottom: 2, elevation: 3 }} key={'onboardingpage-title'}>
              <CardHeader
                title={<Typography variant="h6">{t('page.onboarding.courses.title')}</Typography>}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 16px 16px 16px' }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    window.open('https://learn.medconnect.services/login', '_blank');
                  }}
                >
                  {t('page.onboarding.courses.CTA')}
                </Button>
              </Box>
            </Card>
            {onBoardingSteps.map((step) => {
              return <Step key={step.title} {...step} />
            })}
          </Grid>
        </Grid>
      )}
    </PageContainer>
  )
}

export default OnboardingPage
